export const SLUG = 'SLUG';
export const ID = 'ID';
export const NAME = 'NAME';
export const ALL = 'ALL';